import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import get from 'lodash/get';

import Form from '../../components/NumberRegister/Form';

import { getQuery } from '../../../pages/Paspor/function';
import { postSosBudLetter, getSosBudServiceList, resetNumberRegister } from '../action';
import { getServiceTitle, sosBudType } from '../functions';

const FormPassport = ({
  history,
  i18n,
  postSosBudLetter,
  letterRegis,
  letterService,
  getSosBudServiceList,
  resetNumberRegister
}) => {
  const { data, error, status } = letterRegis;
  const { serviceId, type } = getQuery(history);
  const keyTitle = getServiceTitle(get(letterService, ['data']), serviceId);
  const title = keyTitle && sosBudType[keyTitle] && i18n(`${sosBudType[keyTitle].label}`);
  let errorSaveMessage = '';

  if (status === 'rejected') {
    const message = get(error, ['response', 'data', 'error', 'message']);
    const keyDetail = get(error, ['response', 'data', 'error', 'detail', 0, 'key']);
    const messageDetail = get(error, [
      'response',
      'data',
      'error',
      'detail',
      0,
      'message'
    ]);
    errorSaveMessage = `${message}. ${keyDetail}: ${messageDetail}.`;
  }

  const handleSubmit = (params) => {
    postSosBudLetter({
      name: params.name,
      email: params.email,
      phone: `${params.phone}`,
      state_id: params.office_id,
      service_id: serviceId
    });
  };

  useEffect(() => {
    if (status === 'resolve') {
      const { id } = data || {};
      resetNumberRegister();
      history.push(`/pensosbud/registration/review?uniqueId=${id}&type=${type}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status]);

  useEffect(() => {
    getSosBudServiceList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    return () => {
      resetNumberRegister();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Form
      i18n={i18n}
      submit={handleSubmit}
      service_title={title}
      loadingStatus={status}
      errorSaveMessage={errorSaveMessage}
      useSelfReport={false}
      prependTextPhone='+62'
    />
  );
};

FormPassport.propTypes = {
  history: PropTypes.object,
  i18n: PropTypes.func,
  letterRegis: PropTypes.object,
  postSosBudLetter: PropTypes.func,
  letterService: PropTypes.object,
  getSosBudServiceList: PropTypes.func,
  resetNumberRegister: PropTypes.func
};

const mapStateToProps = (state) => ({
  letterRegis: {
    status: state.sosBudLetterReducer.status,
    error: state.sosBudLetterReducer.error,
    data: state.sosBudLetterReducer.data
  },
  letterService: {
    status: state.sosBudServiceListReducer.status,
    error: state.sosBudServiceListReducer.error,
    data: state.sosBudServiceListReducer.data
  }
});

export default compose(
  connect(mapStateToProps, {
    postSosBudLetter,
    getSosBudServiceList,
    resetNumberRegister
  }),
  withRouter
)(FormPassport);
